"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SevenTwentySevenOptions = void 0;
/** SevenTwentySevenOptions.tsx
 *
 * Game Options for SevenTwentySeven.
 */
const BetLimit_1 = require("../bets/BetLimit");
const CardVersionSetting_1 = require("../enums/CardVersionSetting");
const defaultOptions_1 = require("./defaultOptions");
exports.SevenTwentySevenOptions = {
    versions: [
        {
            title: "2 Card",
            description: "2 Player Cards",
            value: CardVersionSetting_1.CardVersionSetting.TWO_CARD,
            default: true,
            flavor: 2,
            betLimit: BetLimit_1.BetLimit.SPREAD_LIMIT,
        },
        {
            title: "3 Card",
            description: "3 Player Cards",
            value: CardVersionSetting_1.CardVersionSetting.THREE_CARD,
            flavor: 3,
            betLimit: BetLimit_1.BetLimit.SPREAD_LIMIT,
        },
    ],
    winners: [defaultOptions_1.winnerHighLowSplitDefault],
    options: [defaultOptions_1.optionNoneDefault, defaultOptions_1.optionRollYourOwn],
    wildcards: [defaultOptions_1.wildcardNoneDefault],
};
//# sourceMappingURL=SevenTwentySevenOptions.js.map